export const eAuth = {
  login: '/authentication/login',
  logout: '/authentication/logout',
  me: '/authentication/me',
  user: '/user/',
  changePassword: '/user/update_password', // put /user/update_password body: { old_user_password, user_password, confirm_new_user_password }
  forgot: '/user/forgot_password', // POST /user/forgot_password body: {user_email}
  verify: '/user/validate_link', // PUT /user/validate_link query: {verification_token}
  newPassword: '/user/new_password', // POST /user/new_password body: {user_password, confirm_user_password,verification_token}
  resendVerification: '/user/resend_verification_code' // POST /user/resend_verification_code body: {user_email}
}
